import FontFaceObserver from 'fontfaceobserver';

export const loadFont = (
  name: string,
  props?: FontFaceObserver.FontVariant,
  update?: (progress: number) => void,
): Promise<void> =>
  new Promise((resolve) => {
    new FontFaceObserver(name, props || {})
      .load()
      .then(() => {
        if (update !== undefined) update(1);
        resolve();
      })
      .catch(() => {
        resolve();

        console.warn(`${name}  with ${props} could not be loaded`);
      });
  });
